const testimony2 = `<b>" Une réelle rencontre humaine et professionnelle. Les soins apportés sont de qualités et d'efficacités. Je recommande chaudement ce professionnel qui vous aidera et sera à votre écoute. Merci ! "</b>
<br />-<b> Marianne</b>`;

const testimony5 = `<b>" Personne très sympathique, à l écoute , patiente, on obtient de bons résultats "</b>
<br />-<b> Marie C</b>`;
const testimony6 = `<b>" Cindy m'a fait un massage des 5 continents et c'était juste wahoo!! Je suis encore sur un petit nuage ☁️🥰<br />
Vous pouvez y aller les yeux fermés !<br />

J'ai également bénéficié d'une consultation fleurs de Bach pour ma fille et moi même et c'est génial car Cindy nous a offert de préparer nous même nos fleurs. 🙌<br />

Merci beaucoup Cindy pour la douceur, le professionnalisme et la générosité. "</b>
<br />-<b> Julia</b>`;
const testimony7 = `<b>" Cindy est une personne douce et tellement a l'écoute des gens
J'ai été touchée par son professionnalisme et son investissement
J'ai notamment pu bénéficier de ses conseils et soins en fleur de Bach pour mon enfant. Cela m'a grandement aidé à l'apaiser
Je recommande grandement

J'ai également bénéficié de 2 massages : celui du visage et le massage au pochon Un réel moment de détente
A chaque visite, une agréable surprise !
Environnement apaisant, rempli de sérénité "</b>
<br />-<b> Amandine Garambois
</b>`;

export const all_testimonies = [
  testimony2,
  testimony5,
  testimony6,
  testimony7,
];
